import {
  IWidgetControllerConfig,
  IViewerScript,
  IAppData,
  IPlatformAPI,
  IWixAPI,
  IPlatformServices,
} from '@wix/native-components-infra/dist/src/types/types';
import {createAppController} from './appController';
import {withErrorReporting} from '@wix/wixstores-client-core/dist/es/src/viewer-script/errorReporter';
import {CurrencyConverterSiteStore} from './currencyConverterSiteStore';

export interface IContext {
  siteStore?: CurrencyConverterSiteStore;
}
export type ICurrencyConverterWidgetControllerConfig = IWidgetControllerConfig & {context?: IContext};

const createErrorReportingWrapper = config => {
  const reportError: any = config.platformAPIs.monitoring.createMonitor(
    'https://8c4075d5481d476e945486754f783364@sentry.io/1865790'
  );
  const setPropsWithErrorsReporting = p => config.setProps(withErrorReporting(reportError)(p));
  return withErrorReporting(reportError)(
    createAppController(
      {
        ...config,
        setProps: setPropsWithErrorsReporting,
      },
      context,
      reportError
    )
  );
};

const createControllers = (appControllerConfig: ICurrencyConverterWidgetControllerConfig[]) => {
  return appControllerConfig.map(config => createErrorReportingWrapper(config));
};

let context: IContext = {};
export const createViewerScript: IViewerScript = {
  initAppForPage: (
    initParams: IAppData,
    apis: IPlatformAPI,
    namespaces: IWixAPI,
    platformServices: IPlatformServices
  ) => {
    context.siteStore = new CurrencyConverterSiteStore(initParams, apis, namespaces, platformServices);
    return Promise.resolve();
  },
  // @ts-ignore
  createControllers: (appControllerConfig: IWidgetControllerConfig[]) => {
    return createControllers(appControllerConfig);
  },
};
